if (!AoPS.hasOwnProperty("Community")) {
	AoPS.Community = {};
}

AoPS.Community.Constants = {
	base_url: "https://" + location.hostname,

	community_main_color: "#009fad",

	community_secondary_color: "#dae7f6",

	privates_main_color: "#009fad",

	privates_secondary_color: "#dae7f6",

	time_limits: {
		watched_times_short: 3600, // 1 hour
		watched_times_long: 21600, // 6 hours
	},

	max_times_to_watch: {
		watched_times_short: 1000,
		watched_times_long: 1500,
	},

	very_large_time: 6000000000,

	// Topics older than this will update using topic_update_interval_long.
	old_topic_age_in_seconds: 12 * 60 * 60,

	intervals: {
		// Defaults to equal "active".
		current: {
			// Used to for fetching of new topics.
			new_item_check_interval: 2 * 60 * 1000,
			new_item_check_interval_long: 4 * 60 * 1000,
			// Used for updates of new posts in a topic.
			topic_update_interval: 60 * 1000,
			topic_update_interval_long: 5 * 60 * 1000,
			// Used for fetching of reported posts on Reported Posts page.
			reported_posts_interval: 20 * 1000,
			// Used for updating the avatar preview of who is looking at this thread.
			watchers_updates_check_interval: 5 * 60 * 1000,
			// Used for updating count of how many users looking at this forum.
			fetch_forum_users_interval: 5 * 60 * 1000,
			// Time before putting community to sleep, stopping ajax activity.
			put_community_to_sleep_limit: 20 * 60 * 1000,
		},

		// The default mode.
		active: {
			new_item_check_interval: 2 * 60 * 1000,
			new_item_check_interval_long: 4 * 60 * 1000,
			topic_update_interval: 60 * 1000,
			topic_update_interval_long: 5 * 60 * 1000,
			reported_posts_interval: 20 * 1000,
			watchers_updates_check_interval: 5 * 60 * 1000,
			fetch_forum_users_interval: 5 * 60 * 1000,
			put_community_to_sleep_limit: 20 * 60 * 1000,
		},

		// Throttled. Work slower, sleep sooner.
		slow: {
			new_item_check_interval: 4 * 60 * 1000,
			new_item_check_interval_long: 8 * 60 * 1000,
			topic_update_interval: 2 * 60 * 1000,
			topic_update_interval_long: 10 * 60 * 1000,
			reported_posts_interval: 2 * 60 * 1000,
			watchers_updates_check_interval: 10 * 60 * 1000,
			fetch_forum_users_interval: 10 * 60 * 1000,
			put_community_to_sleep_limit: 15 * 60 * 1000,
		},

		// Do nothing!
		// 2147483647 is the maximum value supported by setTimeout (~24 days).
		disabled: {
			new_item_check_interval: 2147483647,
			topic_update_interval: 2147483647,
			topic_update_interval_long: 2147483647,
			reported_posts_interval: 2147483647,
			watchers_updates_check_interval: 2147483647,
			fetch_forum_users_interval: 2147483647,
		},
	},

	// How often we check if the user is idle.
	idle_monitor_interval: 1000,

	// How often to fetch office hours locations / is_typing
	fetch_office_hours_interval: 30 * 1000,

	moment_offset: 0, // Guess at the difference between the server time and the client.
	// Should be reset on page load.

	// Number of seconds to delay on first failure.
	base_delay_internet_issue: 10,

	time_limit_for_calendar_style: 172800, // 2 days.

	// Note: currently we have turned off limiting post editing time.
	//  We will have to make some code changes in the master model,
	//  in the designation of "editable" on the back end
	//  and in the permission check on the back end upon editing a post
	//  if we change our mind
	time_limit_edit_own: 1209600, // 2 weeks, match CmtyConstants::EDIT_OWN_POST_TIME_LIMIT

	time_limit_delete_own: 1209600, // 2 weeks, match CmtyConstants::DELETE_OWN_POST_TIME_LIMIT

	// Milliseconds between checks of the times on topics and posts we are watching. (one minute)
	watched_times_short_interval: 59800, //60000,

	// Milliseconds between checks of the times on topics and posts we are watching that are over an hour old.
	watched_times_long_interval: 1200137,

	// ITEMS WHOSE TIMES I PUSH BACK HAVE %%%% above

	// Milliseconds between checks for new topics/posts/etc
	// Should equal new_item_check_interval_short by default
	// %%%%
	UNUSED_new_item_check_interval: 60103, //60000,

	// Milliseconds between checks for new topics/posts/etc when feed active or in the community
	UNUSED_new_item_check_interval_short: 60103, //60000,

	// Must be shorter time than CmtyConstants::$realtime_cache_lookback in /m/community/includes/class.CmtyConstants.php
	// Milliseconds between checks for new topics/posts/etc when feed inactive and not in the community
	UNUSED_new_item_check_interval_long: 240103, //60000,

	// Milliseconds between checks for update to a topic we're looking at right now.
	// %%%%
	UNUSED_topic_update_interval: 38741, // usually around 20s

	// Milliseconds between checks for update to an old topic we're looking at right now.
	// %%%%
	UNUSED_topic_update_interval_long: 218741, // usually around 2 minutes

	// Milliseconds between checks for more reported posts data
	// only active on the reported posts page
	UNUSED_reported_posts_interval: 20341,

	// Milliseconds between checks for updates of the watchers (around 1.5 minutes)
	//  Update only executes if no other Ajax calls are running
	// %%%%
	UNUSED_watchers_updates_check_interval: 195091, // usually around 1.5min

	// Milliseconds between checks for updates of forum users data when viewing a folder.
	UNUSED_fetch_forum_users_interval: 81137, // Little over 80 seconds.

	// Any width below this throws us in phone mode in the community.
	phone_mode_max_width: 768,

	// Minimum available post window height in which one can preview a reply.
	min_preview_height: 320,

	// Minimum height at which we can drag reply window divider
	min_draggable_reply_height: 290,

	// Minimum height window for viewing posts
	min_posts_window_height: 50,

	// If user has a really short (height) browser, we peg the
	//  reply textarea to this.  We don't let it go lower,
	//  or the reply window will be broken when they expand.
	min_stupid_view_reply_textarea: 50,

	// Max number of students in a private conversation
	max_conversation_participants: 10,

	// If a folder has more than this many boxes in it, then we aren't going
	//  to try to update the uusers data realtime when viewing that folder's
	//  toplevel page; match MAX_FORUMS_FETCH_USERS on front
	max_forums_user_update: 50,

	// If less than this number of topics are already loaded
	// to a topic list, then go get more before building.  (This number should always
	//  be greater than the number of global announcements.
	min_topic_list_initial_length: 6,

	// Make number of topics to have visible in a topics list at one time
	max_num_shown_topics: 78,

	// Number of topics to hide if we go over the max to show
	num_topics_to_hide: 20,

	// Number of topics to show if we hit an end of a topics list that has
	//  some hidden topics revealed just beyond the ned.
	num_topics_to_reveal: 10,

	// ID of the category for the toplevel AoPS page.
	master_category_id: 2,

	// ID of the portal
	portal_category_id: 89,

	// Category ID Of private messages
	private_messages_id: 1,

	aops_forums_id: 11,

	other_forums_id: 9,

	olympiad_forum_id: 6,
	college_math_forum_id: 7,
	recycle_bin_id: 22,
	blog_recycle_bin_id: 104,

	aops_videos_id: 64,
	aops_wiki_id: 65,

	aops_blogroll_id: 88,

	halp_user_id: 10,

	unsearchable_fora: [50, 63],

	/**
	 * If you edit either of the lists below, then edit the corresponding content in
	 * 	m/community/views/default/community_lang_tpl_en.html
	 **/
	essential_tags_olympiad: [
		"algebra",
		"geometry",
		"combinatorics",
		"number theory",
		"inequalities",
		"imo",
	],
	essential_tags_college: [
		"calculus",
		"real analysis",
		"linear algebra",
		"superior algebra",
		"complex analysis",
		"advanced fields",
		"probability and stats",
		"number theory",
		"topology",
		"putnam",
		"college contests",
	],

	private_archive_url: "/my-messages-archive/",

	// If this many pixels or fewer from the bottom of topic, then jump to bottom
	//  when click reply.
	reply_jump_to_bottom_window: 100,

	move_topic_quick_links: {
		3: [4, 5, 6, 7],
		4: [3, 5, 6, 7],
		5: [3, 4, 6, 7],
		6: [3, 4, 5, 7],
		7: [3, 4, 5, 6],
	},

	min_topic_title_length: 8,

	max_topic_title_length: 80,

	max_tags_per_topic: 7, // Matches MAX_TAGS_PER_TOPIC on back

	min_poll_question_length: 8,

	max_poll_question_length: 255,

	min_post_length: 8,

	max_post_length: 40000,

	max_source_length: 128,

	posting_ajax_timeout: 60000, // milliseconds before timeout when posting

	posting_warn_limit: 20, // If less than this number of characters, then don't warn about closing a posting window.

	time_hack_nudge: 20000, // Milliseconds by which we nudge time to get the realtime "a few seconds ago" time to
	// not render stupid stuff like "a few seconds from now"

	new_topic_modal_delay: 1200, // Milliseconds of delay for the new topic model blocker

	new_reply_modal_delay: 1200, // Milliseconds of delay for the new topic model blocker

	message_readability_delay: 1200, // Milliseconds of delay for a typical blocker message

	message_readability_delay_short: 1200, // Milliseconds of delay for a typical blocker message

	num_posts_to_fetch: 20, // Number of posts to fetch on a call for more posts.

	topic_move_length_limit: 250, // Max number of posts on topic a non-admin can delete/move

	user_path: "/community/user/",

	max_shout_length: 255,

	/** Width of the input box in tagboxes, private conversation recipients, etc. **/
	itembox_input_width: 150,

	// Maximum number of categories to load at once when going through a forum.
	max_categories_to_load: 10,

	category_autocomplete_width: 275,

	tag_autocomplete_width: 250,

	profile_field_length_limit: 120, // Max number of characters in one of the fields of profile

	min_password_length: 8,

	max_password_length: 128,

	// Max file size of an avatar, in kb.
	max_avatar_file_size: 24,

	// Max file size of an attachment, in kb
	max_attachment_size: 512,

	max_attachments_per_post: 3,

	default_avatar: "//avatar.artofproblemsolving.com/no-avatar.png",

	attachment_path: AoPS.bootstrap_data.cmty_attachment_path,

	/***

		Start Feed

	***/

	// Max number of topics we'll check for having been read when doing a "is this list read" check
	max_length_feed_list_read_check: 100,

	/***

		End feed

	***/

	/****

	Start view posts

	***/

	view_post_max_label_len: 12,

	view_post_max_hide_label_len: 255,

	/***

	End view posts

	**/

	// Should match CmtyConstants::$can_ban_from_memberlist
	can_oneclick_ban: [1163, 29411, 225249, 267794],

	/**
		Start Category admin/create
	**/
	max_category_name_length: 50,

	min_category_name_length: 3,

	max_category_description_length: 240,

	// Max length of input fields in blog settings admin
	max_blog_comments_text_length: 40,

	// Time delay before changes to input fields are saved.
	cat_admin_save_input_delay: 1000,

	// Categories that, when private, can still have roles besides the creator as owner.
	// Must match CmtyCategory::canHaveRolesOnPrivate() on back end.
	categories_with_private_roles: ["forum", "forum_class", "blog"],

	/**
		End Category admin/create
	**/

	monitor_tags: [
		{
			item_id: 6,
			item_text: "/not_monitored",
		},
		{
			item_id: 5,
			item_text: "/closed",
		},
		{
			item_id: 4,
			item_text: "/open",
		},
	],

	monitoring_tag_id_array: [4, 5, 6],

	monitored_topic_tag_ids: {
		open: 4,
		closed: 5,
		not_monitored: 6,
	},

	/* Number of pixels from bottom that window scroll (in phone mode)
	must be in order to trigger an autoload of topics */
	phone_more_topics_sensitivity: 150,

	/* Number of pixels from bottom that window scroll (in phone mode)
	must be in order to trigger an autoload of posts */
	phone_more_posts_sensitivity: 150,

	// bbCode settings
	bbCode: {
		// BBcode smiley image files.
		smileys: [
			[":D", "icon_mrgreen.gif"],
			[":blush:", "redface_anim.gif"],
			[":maybe:", "unsure.gif"],
			[":-D", "biggrin.gif"],
			[":)", "smile.gif"],
			[":(", "sad.gif"],
			[":o", "ohmy.gif"],
			[":mad:", "mad.gif"],
			[":P", "tongue.gif"],
			[":oops:", "blush.gif"],
			[":roll:", "rolleyes.gif"],
			[";)", "wink.gif"],
			[":!:", "exclaim.gif"],
			[":idea:", "idea.gif"],
			[":arrow:", "icon2.gif"],
			[":|", "mellow.gif"],
			[":rotfl:", "rotfl.gif"],
			[":huh:", "huh.gif"],
			[":ninja:", "ph34r.gif"],
			[":no:", "sleep.gif"],
			[":love:", "wub.gif"],
			[":wacko:", "wacko.gif"],
			[":what?:", "blink.gif"],
			[":alien:", "alien_grn.gif"],
			[":cool:", "cool.gif"],
			[":first:", "first.gif"],
			[":dry:", "dry.gif"],
			[":laugh:", "laugh.gif"],
			[":coolspeak:", "coolspeak.gif"],
			[":oops_sign:", "oops.gif"],
			[":whistling:", "whistling.gif"],
			[":yinyang:", "yinyang.gif"],
			[":w00t:", "w00t.gif"],
			[":pilot:", "plane.gif"],
			[":play_ball:", "play_ball.gif"],
			[":police:", "police.gif"],
			[":read:", "read.gif"],
			[":showoff:", "showoff.gif"],
			[":sleep2:", "sleep2.gif"],
			[":sleeping:", "sleeping.gif"],
			[":spam:", "spam.gif"],
			[":spidy:", "spidy.gif"],
			[":starwars:", "starwars.gif"],
			[":stink:", "stink.gif"],
			[":stretcher:", "stretcher.gif"],
			[":cleaning:", "suck_kr.gif"],
			[":surf:", "surfing.gif"],
			[":surrender:", "surrender.gif"],
			[":thumbup:", "thumbup.gif"],
			[":trampoline:", "trampoline.gif"],
			[":w00tb:", "w00tbrows.gif"],
			[":wallbash:", "wallbash.gif"],
			[":wallbash_red:", "wallbash_red.gif"],
			[":weightlift:", "weightlift.gif"],
			[":welcome:", "welcome.gif"],
			[":welcomeani:", "welcomeani.gif"],
			[":winner_first:", "winner_first_h4h.gif"],
			[":winner_second:", "winner_second_h4h.gif"],
			[":winner_third:", "winner_third_h4h.gif"],
			[":wow:", "wow.gif"],
			[":huuh:", "wtf.gif"],
			[":yankchain:", "yankchain.gif"],
			[":yup:", "yes3.gif"],
			[":10:", "10.gif"],
			[":heli:", "heli.gif"],
			[":agent:", "agent.gif"],
			[":bomb:", "bomb.gif"],
			[":bruce:", "bruce_h4h.gif"],
			[":bye:", "byebye.gif"],
			[":censored:", "censored.gif"],
			[":chief:", "chieftain.gif"],
			[":clap:", "clap.gif"],
			[":clap2:", "clap2.gif"],
			[":coool:", "cool1.gif"],
			[":ddr:", "ddr.gif"],
			[":diablo:", "diablo.gif"],
			[":evilgrin:", "evilgrin.gif"],
			[":ewpu:", "ewpu.gif"],
			[":flex:", "flex.gif"],
			[":fool:", "fool.gif"],
			[":football:", "football.gif"],
			[":furious:", "furious.gif"],
			[":gathering:", "gathering.gif"],
			[":gleam:", "gleam.gif"],
			[":harhar:", "harhar.gif"],
			[":help:", "helpsmilie.gif"],
			[":icecream:", "icecream.gif"],
			[":juggle:", "juggle[1].gif"],
			[":jump:", "jump.gif"],
			[":moose:", "mf_moose.gif"],
			[":nhl:", "nhl.gif"],
			[":noo:", "no.gif"],
			[":omighty:", "notworthy.gif"],
			[":yoda:", "yoda.gif"],
		],
		// Colors in the bbCode font color popup
		font_colors: [
			"#f00",
			"#ff9a00",
			"#ff0",
			"#0f0",
			"#0ff",
			"#00f",
			"#9a00ff",
			"#f0f",
			"#600",
			"#783F04",
			"#7f6000",
			"#274E13",
			"#0C343D",
			"#073763",
			"#20124D",
			"#4C1130",
			"#960000",
			"#B45F06",
			"#BF9000",
			"#38761D",
			"#134F5C",
			"#0B5394",
			"#351C75",
			"#741B47",
			"#c00",
			"#E69138",
			"#F1C232",
			"#6AA84F",
			"#45818E",
			"#3D85C6",
			"#674EA7",
			"#A64D79",
			"#E06666",
			"#F6B26B",
			"#FFD966",
			"#93C47D",
			"#76A5AF",
			"#6FA8DC",
			"#8E7CC3",
			"#C27BA0",
			"#EA9999",
			"#F9CB9C",
			"#FFE599",
			"#B6D7A8",
			"#A2C4C9",
			"#9FC5E8",
			"#B4A7D6",
			"#D5A6BD",
			"#F4CCCC",
			"#FCE5CD",
			"#FFF2CC",
			"#D9EAD3",
			"#D0E0E3",
			"#CFE2F3",
			"#D9D2E9",
			"#EAD1DC",
			"#000",
			"#222",
			"#444",
			"#666",
			"#888",
			"#aaa",
			"#ccc",
			"#eee",
		],
		// font_sizes defined in community_lang.js
		// extra_options defined in community_lang.js
	},

	special_collections_id: 12,

	//Must match CmtyConstants::$office_hours_ids in class.CmtyConstants.php
	office_hours_ids: [433798],

	BIG: 100000000, // Arbitrary big number to allow sensible "if variable less than blah, where blah defaults big so we always get one"
};

// MORE CONSTANTS SET IN community_lang.js, since they require language fields
//  (Maybe move to community_lang_const)
